var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9834 4.15866L10.8412 1.0171C10.7367 0.912603 10.6127 0.829713 10.4762 0.77316C10.3397 0.716607 10.1933 0.6875 10.0456 0.6875C9.89783 0.6875 9.75152 0.716607 9.61501 0.77316C9.4785 0.829713 9.35447 0.912603 9.25 1.0171L0.579771 9.68733C0.474851 9.79142 0.391667 9.91532 0.335055 10.0518C0.278443 10.1884 0.249534 10.3348 0.250006 10.4826V13.6248C0.250006 13.9232 0.368532 14.2093 0.57951 14.4203C0.790489 14.6313 1.07664 14.7498 1.37501 14.7498H13.1875C13.3367 14.7498 13.4798 14.6906 13.5853 14.5851C13.6907 14.4796 13.75 14.3365 13.75 14.1873C13.75 14.0381 13.6907 13.8951 13.5853 13.7896C13.4798 13.6841 13.3367 13.6248 13.1875 13.6248H6.10844L13.9834 5.74983C14.0879 5.64536 14.1708 5.52133 14.2274 5.38482C14.2839 5.24831 14.313 5.102 14.313 4.95424C14.313 4.80649 14.2839 4.66017 14.2274 4.52367C14.1708 4.38716 14.0879 4.26313 13.9834 4.15866ZM4.51727 13.6248H1.37501V10.4826L7.56251 4.29506L10.7048 7.43733L4.51727 13.6248ZM11.5 6.6421L8.35844 3.49983L10.0459 1.81233L13.1875 4.9546L11.5 6.6421Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4975e3d361976ab6b272cddafc90650e.svg";
export { ForwardRef as ReactComponent };